import { Link } from "react-router-dom";

const columnLinks = [
  { label: "求番推荐", to: "/recommend" },
  { label: "避雷指南", to: "/avoid" },
  { label: "补番顺序", to: "/order" },
  { label: "漫评讨论", to: "/review" },
];

const helpLinks = [
  { label: "关于我们", to: "/about" },
  { label: "联系我们", to: "/contact" },
  { label: "投稿安利", to: "/contact" },
  { label: "补番攻略", to: "/order" },
];

const socials = [
  { icon: "ri-weibo-line", label: "微博" },
  { icon: "ri-bilibili-line", label: "哔哩哔哩" },
  { icon: "ri-discord-line", label: "Discord" },
  { icon: "ri-mail-line", label: "邮箱" },
];

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="container-x grid grid-cols-1 gap-10 py-14 sm:grid-cols-2 lg:grid-cols-4 md:py-16">
        <div>
          <Link to="/" className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-lg text-background-50">
              <i className="ri-ancient-pavilion-line"></i>
            </span>
            <span className="font-heading text-xl text-background-50">新御宅屋</span>
          </Link>
          <p className="mt-4 text-sm leading-6 text-background-300/80">
            一个属于动漫同好的社区：求番推荐、私藏安利、漫评讨论与避雷指南随时可查。不知道下一部看什么，来这里问、来这里翻。
          </p>
          <div className="mt-5 flex gap-2">
            {socials.map((s) => (
              <a
                key={s.label}
                href="#"
                rel="nofollow"
                aria-label={s.label}
                className="flex h-9 w-9 items-center justify-center rounded-full bg-background-800/60 text-base text-background-300 transition-colors duration-200 hover:bg-primary-500 hover:text-background-50"
              >
                <i className={s.icon}></i>
              </a>
            ))}
          </div>
        </div>

        <div>
          <h4 className="font-heading text-base text-background-50">内容栏目</h4>
          <ul className="mt-4 space-y-2.5">
            {columnLinks.map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="text-sm text-background-300/80 transition-colors duration-200 hover:text-primary-300">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-base text-background-50">快速帮助</h4>
          <ul className="mt-4 space-y-2.5">
            {helpLinks.map((l) => (
              <li key={l.label}>
                <Link to={l.to} className="text-sm text-background-300/80 transition-colors duration-200 hover:text-primary-300">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-base text-background-50">加入我们</h4>
          <p className="mt-4 text-sm leading-6 text-background-300/80">
            想一起安利好番、聊聊剧情？欢迎成为同好一员，分享你的私藏安利与漫评。
          </p>
          <Link
            to="/contact"
            className="mt-5 inline-flex whitespace-nowrap items-center justify-center rounded-full bg-primary-500 px-5 py-2.5 text-sm font-bold text-background-50 transition-colors duration-200 hover:bg-primary-600"
          >
            立即投稿
          </Link>
        </div>
      </div>

      <div className="border-t border-background-800/60">
        <div className="container-x flex flex-col items-center justify-between gap-3 py-6 sm:flex-row">
          <p className="text-xs text-background-400">
            © {new Date().getFullYear()} 新御宅屋 · 动漫同好社区，用心做内容，陪你追完每一部好番。
          </p>
          <div className="flex items-center gap-4 text-xs text-background-400">
            <Link to="/about" className="transition-colors hover:text-primary-300">关于我们</Link>
            <Link to="/contact" className="transition-colors hover:text-primary-300">联系我们</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}